import React from "react";

import styled from "styled-components";
import { space, SpaceProps, layout, LayoutProps, display } from "styled-system";

interface StyledProps extends SpaceProps, LayoutProps {
  children?: React.ReactNode;
}


interface BinProps extends StyledProps {
  color?: string;
}

const StyledContainer = styled.div<StyledProps>`
  display: flex;
  ${display}
  ${space}
  ${layout}
`;

const NOXEmissionsSVG: React.FunctionComponent<BinProps> = ({ ...rest }) => {
  return (
    <StyledContainer {...rest}>
      <svg width="19" height="15" fill="none" viewBox="0 0 19 15">
        <path
          fill="#070B16"
          d="M16.775 9.41a1.4 1.4 0 00-.611-1.732c-.608-.34-1.35-.187-1.802.366-.447-1.128-1.68-1.702-2.845-1.38-1.165.321-1.871 1.526-1.626 2.713-.015 0-.033-.004-.048-.004a2.324 2.324 0 00-2.317 2.344c0 1.292 1.05 2.344 2.317 2.344h6.536a2.335 2.335 0 002.337-2.154 2.296 2.296 0 00-1.94-2.497zM5.13 4.426v3.282c0 .388.315.703.676.703.362 0 .677-.315.677-.703V4.426c0-.388-.315-.703-.677-.703-.361 0-.676.34-.676.703zM1.848 12.63c-.26 0-.442-.208-.442-.468V2.786c0-.26.209-.47.442-.47h9.35c.26 0 .441.21.441.47v2.856c.154-.026.312-.04.443-.044.326 0 .637.062.911.154V2.787c0-1.036-.839-1.875-1.848-1.875h-9.35C.76.912-.052 1.751-.052 2.787v9.375c0 1.037.839 1.875 1.849 1.875h5.68a3.258 3.258 0 01-.838-1.406h-4.79v-.002zm.938-8.203v3.282c0 .388.315.703.677.703.362 0 .676-.315.676-.703V4.426c0-.388-.314-.703-.676-.703-.362 0-.677.34-.677.703z"
        />
      </svg>
    </StyledContainer>
  );
};

export default NOXEmissionsSVG;
